import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";
import {Router} from "@angular/router";
import {UserService} from "../../../service/user.service";


@Component({
  selector: 'app-digital-business-cards',
  templateUrl: './digital-business-cards.component.html',
  styleUrls: ['./digital-business-cards.component.scss', './digital-business-cards-media.component.scss']
})
export class DigitalBusinessCardsComponent {
  currentLang: string = '';

  constructor(private router: Router,
              public translate: TranslateService,
              private userService: UserService) {
    this.translate.addLangs([Language.HY, Language.EN, Language.RU]);
    this.translate.setDefaultLang(Language.HY);
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  navigateToSignUp() {
    const userToken=this.userService.token;
    if (userToken) {
      this.router.navigate(['/cards']);
    } else this.router.navigate(['/sign-up']);
  }

  onLanguageChange(event: any) {
    const language = event.target.value;
    this.switchLanguage(language);
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  protected readonly Language = Language;
}
